import { api } from "../api";

export const settingApi = {
    getCdnUrl: () => api.get('api/setting/cdn'),
    getMode: () => api.get('api/setting/environment'),
}